// frontend/src/utils/responseShaper.js
import shapingRules from './shaping/shapingRules';

function renderTemplate(template, context = {}) {
  return template.replace(/{{(\w+)}}/g, (_, key) => context[key] || '');
}

function shapeResponse(rawReply, context = {}) {
  const { intent, target, userName = 'friend', memoryName, emotionLevel = 0 } = context;
  const trimmedReply = rawReply.trim();

  console.log('🔧 [Shaper] Raw reply:', trimmedReply);
  console.log('🔧 [Shaper] Context:', context);

  const rule = shapingRules[intent];
  const tier = rule?.shapingTier || 'mid';
  console.log(`📐 [Shaper] Tier selected: ${tier}`);

  const promptInstruction = rule?.promptInstruction;
  if (promptInstruction) {
    console.log(`🧠 [PromptInjection] Using tier: ${tier} →`, promptInstruction);
    context.promptInstruction = promptInstruction;
  }
  console.log('🔧 [Shaper] Context after prompt injection:', context);

  if (tier === 'short') {
    if (rule?.variants?.length) {
      const variant = rule.variants[Math.floor(Math.random() * rule.variants.length)];
      return renderTemplate(variant, { userName, target, memoryName });
    }
  }

  if (tier === 'mid') {
    if (rule?.variants?.length && trimmedReply.length < 100) {
      console.log('🔁 [Shaper] Mid-tier fallback: LLM too short → using variant');
      const variant = rule.variants[Math.floor(Math.random() * rule.variants.length)];
      return renderTemplate(variant, { userName, target, memoryName });
    }
  }

  if (rule?.useLocal) {
    if (intent === 'recall_request') {
      const variantList = memoryName && rule.specificVariants ? rule.specificVariants : rule.generalVariants;
      if (variantList) {
        const variant = variantList[Math.floor(Math.random() * variantList.length)];
        return renderTemplate(variant, { userName, target, memoryName });
      }
    } else if (rule.variants) {
      const variant = rule.variants[Math.floor(Math.random() * rule.variants.length)];
      return renderTemplate(variant, { userName, target, memoryName });
    }
  }

// Retry fallback — short or unhelpful LLM replies
const isEmpty = !trimmedReply || trimmedReply.length === 0;
const isWeakMid = tier === 'mid' && trimmedReply.length < 100;
const isWeakFull = tier === 'full' && trimmedReply.length < 120;

if ((isEmpty || isWeakMid || isWeakFull) && rule?.variants?.length) {
  console.log('🔁 [Shaper Retry] Weak LLM response — falling back to variant');
  const variant = rule.variants[Math.floor(Math.random() * rule.variants.length)];
  return renderTemplate(variant, { userName, target, memoryName });
}

  return trimmedReply;
}

export { shapeResponse };


